import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-p-4 tw-text-center"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "You don't have an active account.", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@spellingframe.co.uk" }, "support@spellingframe.co.uk", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!
  const _component_ContactLink = _resolveComponent("ContactLink")!
  const _component_MfJoinError = _resolveComponent("MfJoinError")!

  return (_ctx.showNoAccessError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.accessStatus == 'inactive')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.isIndividual)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                    _createTextVNode(" Your account isn't active. "),
                    _createVNode(_component_SfRouterLink, { to: "/purchase/individual" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Reactivate your account")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(". ")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    (_ctx.isStudent)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Please discuss this with your teacher."))
                      : (!_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("p", null, " Please discuss this with your school administrator (" + _toDisplayString(_ctx.$currentUser.value!.school!.adminName) + "). ", 1),
                            _createElementVNode("p", null, [
                              _createTextVNode(" If you need to change your school administrator "),
                              _createVNode(_component_ContactLink),
                              _createTextVNode(". ")
                            ])
                          ]))
                        : _createCommentVNode("", true)
                  ]))
            ]))
          : (_ctx.mfMovedError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_MfJoinError, {
                  error: "mfUserMoved",
                  class: "tw-text-left"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Use your Spellingframe credentials ")
                  ]),
                  _: 1
                })
              ]))
            : (_ctx.accessStatus == 'nosubject')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_ctx.currentSubject)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, " You don't have access to " + _toDisplayString(_ctx.currentSubjectLabel) + " area of the site. ", 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_11, "You don't have access to this area of the site.")),
                  (_ctx.isStudent)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Please discuss this with your teacher."))
                    : (!_ctx.isAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("p", null, " Please discuss this with your school administrator (" + _toDisplayString(_ctx.$currentUser.value!.school!.adminName) + "). ", 1),
                          _createElementVNode("p", null, [
                            _createTextVNode("If you need to change your school administrator "),
                            _createVNode(_component_ContactLink),
                            _createTextVNode(".")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_14, "You have no access to this area."))
      ]))
    : (_ctx.showFailedError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createTextVNode(" There was an error loading you user info. Please check your connection and try again. If the error continues please contact me at "),
          _hoisted_16
        ]))
      : _createCommentVNode("", true)
}